import React from 'react'
import ImgLeft from '@app/assets/images/banner-l.png'
import ImgRight from '@app/assets/images/banner-r.png'

import { Icon } from '@iconify/react'
import { FormattedMessage } from 'react-intl'
import S from './Banner.styles'

interface BannerProps {
  firstName: string // An array of image URLs
}
const Banner: React.FC<BannerProps> = ({ firstName: _ }) => {
  return (
    <S.BannerContainer>
      <S.LeftImage src={ImgLeft} alt="Left Image" />
      <S.Content>
        <S.HeroIcon>
          <Icon icon="fe:check" fontSize={40} />
        </S.HeroIcon>
        <S.TextContainer>
          <FormattedMessage id="order_confirmation_page.content.banner.title" />
        </S.TextContainer>
      </S.Content>

      <S.RightImage src={ImgRight} alt="Right Image" />
    </S.BannerContainer>
  )
}

export default Banner
